import Utils from "../Utils";

const DEFAULT_ZOOM = 2;
const DEFAULT_CLOSE_ZOOM = 17;
const FOOTPRINT_ZOOM_THRESHOLD = 15;
const MANUAL_ROTATE_DG = 5;
const PIXEL_SIZE_ZOOM17 = 125;

export default class GoogleMapsController {
  constructor(google, projectData, setStateCallback, defaultSetup) {
    this.defaultSetup = defaultSetup
      ? defaultSetup
      : { lat: 30, lng: 0, rot: 0 };
    this.projectData = projectData;
    this.google = google;
    this.map = null;
    this.marker = null;
    this.footprintShown = false;
    this.setStateCallback = setStateCallback;
    this.myControls = [];
  }

  addRightControl = controlDiv => {
    // Set CSS for the control border.
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginTop = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to rotate object to the right";
    controlUI.className = "unselectable";

    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    var controlText = document.createElement("div");
    controlText.style.fontFamily = "Material Icons";
    controlText.innerHTML = "rotate_right";
    controlText.style.fontSize = "36px";
    controlText.style.userSelect = "none";
    controlText.style.webkitUserSelect = "none";
    controlText.style.msUserSelect = "none";
    controlText.className = "unselectable";
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to Chicago.
    controlUI.addEventListener("click", this.rotateMarkerRight);
  };

  addLeftControl = controlDiv => {
    // Set CSS for the control border.
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginTop = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to rotate object to the left";

    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    var controlText = document.createElement("div");
    controlText.style.fontFamily = "Material Icons";
    controlText.innerHTML = "rotate_left";
    controlText.style.fontSize = "36px";
    controlText.style.userSelect = "none";
    controlText.style.webkitUserSelect = "none";
    controlText.style.msUserSelect = "none";
    controlText.className = "unselectable";
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to Chicago.

    controlUI.addEventListener("click", this.rotateMarkerLeft);
  };

  addCenterBuilding(controlDiv) {
    // Set CSS for the control border.
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.cursor = "pointer";
    controlUI.style.height = "37px";
    controlUI.style.width = "37px";
    controlUI.style.marginRight = "10px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to center you model";
    controlUI.class = "unselectable";
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior.
    var controlText = document.createElement("div");
    controlText.style.fontFamily = "Material Icons";
    controlText.innerHTML = "radio_button_checked";
    //controlText.marginRight = '30px';
    controlText.style.fontSize = "36px";
    controlText.style.userSelect = "none";
    controlText.style.webkitUserSelect = "none";
    controlText.style.msUserSelect = "none";
    controlText.className = "unselectable";
    controlText.class = "unselectable";
    controlUI.appendChild(controlText);

    // Setup the click event listeners: simply set the map to Chicago.
    controlUI.addEventListener("click", this.setBuildingCenter);
  }

  updateMarker = () => {
    let self = this;

    //var maxPixelSize = 350; //restricts the maximum size of the icon, otherwise the browser will choke at higher zoom levels trying to scale an image to millions of pixels

    var zoom = this.map.getZoom();
    //console.log("projectData", this.projectData);
    var relativePixelSize = Utils.googleMarkerPixelSize(
      zoom,
      this.map.getCenter().lat(),
      this.projectData.boundsWidth,
      this.projectData.boundsHeight
    );
    //console.log("relativePixelSize", relativePixelSize);

    let footprintIcon = null;
    // console.log(this.projectData.footprintUrl);
    if (zoom > FOOTPRINT_ZOOM_THRESHOLD && this.projectData.footprintUrl) {
      this.footprintShown = true;
      footprintIcon = {
        url: this.projectData.footprintUrl,
        size: null, //size
        origin: null, //origin
        anchor: new this.google.maps.Point(
          relativePixelSize / 2,
          relativePixelSize / 2
        ), //anchor
        scaledSize: new this.google.maps.Size(
          relativePixelSize,
          relativePixelSize
        ) //changes the scale
      };
    } else {
      this.footprintShown = false;
    }
    //change the size of the icon
    this.marker.setIcon(footprintIcon);
    this.updateMarkerRotation();
    this.updateControlsVisibility(!this.footprintShown);
    //console.log("marker size updated", relativePixelSize);
  };

  updateControlsVisibility(hidden) {
    this.myControls.forEach(ctrl => {
      if (ctrl && ctrl.style) ctrl.style.display = hidden ? "none" : "block";
    });
  }

  initMap = (mapRef, inputRef) => {
    var self = this;

    let position = {
      lat: this.projectData.lat
        ? parseFloat(this.projectData.lat)
        : this.defaultSetup.lat,
      lng: this.projectData.lng
        ? parseFloat(this.projectData.lng)
        : this.defaultSetup.lng
    };

    this.map = new this.google.maps.Map(mapRef, {
      zoom:
        !this.projectData.lat || this.projectData.lat === 30
          ? this.defaultSetup.zoom
          : DEFAULT_CLOSE_ZOOM,
      center: position,
      streetViewControl: false,
      mapTypeId: "satellite",
      tilt: 0
    });

    this.marker = new this.google.maps.Marker({
      position: position,
      map: this.map,
      draggable: true,
      label: null,
      optimized: false,
      icon: null //set the markers icon to the MarkerImage
    });

    this.initAutocomplete(inputRef, this.google);

    //console.log("map ref" + mapRef);

    let overlay = new this.google.maps.OverlayView();
    overlay.draw = function () {
      this.getPanes().markerLayer.id =
        "ml" + self.projectData.projectId;
    };
    overlay.setMap(this.map);

    this.updateMarker();
    //when the map zoom changes, resize the icon based on the zoom level so the marker covers the same geographic area
    this.google.maps.event.addListener(
      this.map,
      "zoom_changed",
      this.updateMarker
    );

    this.google.maps.event.addListener(this.map, "tilt_changed", () => {
      if (self.map.getTilt() !== 0) {
        self.map.setTilt(0);
      }
      self.setStateCallback(self.projectData);
    });

    this.map.addListener("click", event => {
      this.marker.setPosition(event.latLng);
      this.projectData.lat = event.latLng.lat();
      this.projectData.lng = event.latLng.lng();
      console.log(
        "dragged",
        self.projectData.lat,
        self.projectData.lng,
        self.projectData.rot,
        self.setStateCallback
      );
      this.setStateCallback(self.projectData);
    });

    this.google.maps.event.addListener(this.marker, "dragend", event => {
      self.projectData.lat = event.latLng.lat();
      self.projectData.lng = event.latLng.lng();
      console.log(
        "dragged",
        self.projectData.lat,
        self.projectData.lng,
        self.projectData.rot,
        self.setStateCallback
      );
      self.setStateCallback(self.projectData);
    });

    var rightControlDiv = document.createElement("div");
    this.addRightControl(rightControlDiv, this.map);
    rightControlDiv.index = 2;

    var leftControlDiv = document.createElement("div");
    this.addLeftControl(leftControlDiv, this.map);
    leftControlDiv.index = 1;

    var centerBuildingDiv = document.createElement("div");
    this.addCenterBuilding(centerBuildingDiv, this.map);
    centerBuildingDiv.index = 3;

    this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(
      leftControlDiv
    );
    this.myControls.push(leftControlDiv);
    this.map.controls[this.google.maps.ControlPosition.TOP_CENTER].push(
      rightControlDiv
    );
    this.myControls.push(rightControlDiv);
    this.map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(
      centerBuildingDiv
    );

    this.updateMarker();

    setTimeout(() => {
      this.updateMarker();
    }, 1000);
    //console.log("init map finsihed");
  };

  updateMarkerRotation = () => {
    if (!this.projectData || !this.projectData.projectKey) {
      //console.log("marker layer misssing");
      return;
    }
    let markerLayer = document.querySelector(
      "#ml" + this.projectData.projectId + " img"
    );

    if (markerLayer) {
      //markerLayer =markerLayer.parentElement;//rotate parent div instead of img otherwise it will be trimmed
      if (this.footprintShown) {
        markerLayer.style.transform =
          "rotate(" + parseInt(this.projectData.rot) + "deg)";
        //console.log("rot update footprint shown", this.projectData.rot);
      } else {
        markerLayer.style.transform = "rotate(0deg)";
        // console.log("rot update footprint hidden", 0);
      }
    } else {
      //console.log("marker layer misssing");
    }
    this.google.maps.event.clearListeners(this.map, "idle");
    //this.google.maps.event.clearListeners(this.map, "idle");
  };

  rotateMarkerLeft = () => {
    this.projectData.rot = parseInt(this.projectData.rot) - MANUAL_ROTATE_DG;
    this.updateMarkerRotation();
    this.setStateCallback(this.projectData);
    console.log(
      "set move left",
      this.projectData.lat,
      this.projectData.lng,
      this.projectData.rot
    );
  };
  rotateMarkerRight = () => {
    this.projectData.rot = parseInt(this.projectData.rot) + MANUAL_ROTATE_DG;
    this.updateMarkerRotation();
    this.setStateCallback(this.projectData);
    console.log(
      "set move left",
      this.projectData.lat,
      this.projectData.lng,
      this.projectData.rot
    );
  };
  setBuildingCenter = () => {
    this.marker.setPosition(this.map.getCenter());
    this.projectData.lat = this.map.getCenter().lat();
    this.projectData.lng = this.map.getCenter().lng();
    this.setStateCallback(this.projectData);
    console.log(
      "set center",
      this.projectData.lat,
      this.projectData.lng,
      this.projectData.rot
    );
  };

  initAutocomplete = (input, google) => {
    // Create the search box and link it to the UI element.

    var searchBox = new google.maps.places.SearchBox(input);
    //this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

    // Bias the SearchBox results towards current map's viewport.
    this.map.addListener("bounds_changed", () => {
      searchBox.setBounds(this.map.getBounds());
    });

    var markers = [];
    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener("places_changed", () => {
      var places = searchBox.getPlaces();

      if (places.length === 0) {
        return;
      }



      // Clear out the old markers.
      markers.forEach(function (marker) {
        marker.setMap(null);
      });
      markers = [];

      // For each place, get the icon, name and location.
      var bounds = new google.maps.LatLngBounds();
      places.forEach(function (place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry");
          return;
        }

        if (place.geometry.viewport) {
          // Only geocodes have viewport.
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }
      });
      this.map.fitBounds(bounds);

      this.marker.setPosition(places[0].geometry.location);
      this.projectData.lat = this.marker.getPosition().lat();
      this.projectData.lng = this.marker.getPosition().lng();
      this.setStateCallback(this.projectData);

    });
  };
}
